import React from 'react';

export function PageLoader() {
  return (
    <div className="s-container">
      <div className="page-loader__loading-overlay">
        <div className="page-loader__loader" />
      </div>
    </div>
  );
}
